

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form13";
const form13State = namespace("Form13");

import { form13DataInfoType, form13PartiesInfoType } from '@/types/Information/Form13';
import { partiesDataJsonDataType } from '@/types/Information/json';

import AddPartyForm from './AddPartyForm.vue';
import AddPartyModal from './AddPartyModal.vue';

@Component({
    components:{
        AddPartyForm,
        AddPartyModal        
    }
})
export default class Form13StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @form13State.State
    public form13Info: form13DataInfoType;

    @form13State.Action
    public UpdateForm13Info!: (newForm13Info: form13DataInfoType) => void  
    
    @form13State.State
    public currentConsentOrderExtendTimeId: string;

    @form13State.Action
    public UpdateCurrentConsentOrderExtendTimeId!: (newCurrentConsentOrderExtendTimeId: string) => void
    
    dataReady = false;
    updated=0;     
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;

    partyNames: form13PartiesInfoType[] = [];
    

    partyToEdit = {} as form13PartiesInfoType;
    showPartyWindow = false
    isCreate = true
    partyType = ''   
    seekingExtensionOptions = [
        'appeal record',
        'transcript',
        'factum',
        'appeal book',
        'book of authorities'
    ]

    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'counselName', label:'Counsel Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]   

    state = { 
        appellantsInfo: null,
        respondentsInfo: null,
        filingParties: null,
        seekingExtension: null,  
        seekingExtensionOther: null, 
        extensionDate: null,
        signingParties: null               
    }    

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }
    
    public extractInfo(){       

        if(this.currentConsentOrderExtendTimeId){
            this.getForm13Data();
           
        } else { 

            const form13Data = this.form13Info;            
            form13Data.version = this.$store.state.Application.version;
            form13Data.seekingExtension = [];
            form13Data.seekingExtensionOther = '';
            form13Data.filingParties = [];
            form13Data.signingParties = [];
            form13Data.appellants = this.partiesJson.appellants
            form13Data.respondents = this.partiesJson.respondents
            form13Data.formSevenNumber = this.fileNumber; 
            form13Data.orderDate = moment().format("YYYY-MM-DD")
            
            this.UpdateForm13Info(form13Data);           
            this.revaluateForm13Data();            
            this.saveForm(true);
        }          
    }

    public revaluateForm13Data(){

        const form13Data = this.form13Info;

        for (const respondent of form13Data.respondents){
            if (respondent.firstName && respondent.lastName){                    
                respondent.isOrganization = false;
            } else if (respondent.organization){
                respondent.isOrganization = true;
            }
            if(respondent.solicitor?.counselFirstName && respondent.solicitor?.counselLastName)
                respondent.counselName = respondent.solicitor.counselFirstName+' '+respondent.solicitor.counselLastName                          
            respondent.responding = true;
        }

        for (const applicant of form13Data.appellants){
            if (applicant.firstName && applicant.lastName){
                applicant.isOrganization = false;
            } else if (applicant.organization){
                applicant.isOrganization = true;
            }
            if(applicant.solicitor?.counselFirstName && applicant.solicitor?.counselLastName)
                applicant.counselName = applicant.solicitor.counselFirstName+' '+applicant.solicitor.counselLastName             
            applicant.responding = false;
        }

        const appellants = form13Data.appellants.map(resp=>resp.name)
        const respondents = form13Data.respondents.map(resp=>resp.name)
        form13Data.appellantNames = appellants.join(', ');
        form13Data.respondentNames = respondents.join(', ');

        this.partyNames = [...form13Data.appellants, ...form13Data.respondents]
        this.UpdateForm13Info(form13Data);
    }

    public getForm13Data() {        
       
        this.$http.get('/form13/forms/'+this.currentConsentOrderExtendTimeId)
        .then((response) => {
            if(response?.data?.data){
                const form13Data = response.data.data
                this.UpdateForm13Info(form13Data);
                this.revaluateForm13Data();               
                this.clearStates();                
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellantsInfo: null,
            respondentsInfo: null,
            filingParties: null,
            seekingExtension: null,
            seekingExtensionOther: null,
            extensionDate: null,
            signingParties: null            
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){  
        
        this.state.appellantsInfo = this.form13Info.appellants?.length>0? null :false;
        this.state.respondentsInfo = this.form13Info.respondents?.length>0? null :false;            
        this.state.seekingExtension = this.form13Info.seekingExtension?.length>0? null :false
        this.state.seekingExtensionOther = this.form13Info.seekingExtension?.includes('other') && !this.form13Info.seekingExtensionOther? false :null
        this.state.filingParties = this.form13Info.filingParties?.length>0? null :false;
        this.state.extensionDate = this.form13Info.extensionDate? null :false; 
        
        const signingParties = this.form13Info.signingParties?this.form13Info.signingParties:[];
        const signingAppellants = signingParties.filter(party=> !party.responding)
        const signingRespondents = signingParties.filter(party=> party.responding)
        
        this.state.signingParties = (signingAppellants.length>0 && signingRespondents.length > 0)? null :false;
        
        if(dontFindInvalidFields == true) return true     
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form13/forms';

        if (this.currentConsentOrderExtendTimeId){
            method = 'put';
            url = '/form13/forms/'+this.currentConsentOrderExtendTimeId;
            const form13Data = this.form13Info;            
            this.UpdateForm13Info(form13Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form13Info,
                    type:'Form13',
                    description:'Consent order to extend time to file a document'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form13Info,
                    type:'Form13',
                    description:'Consent order to extend time to file a document'
                }
            }
            this.saveInfo(options, draft);
        }
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentConsentOrderExtendTimeId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }

    public addNewRespondent(){
        this.state.respondentsInfo = null
        this.partyToEdit = {} as form13PartiesInfoType
        this.partyType = 'Respondent'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editRespondent(data) {
        this.partyToEdit = data.item
        this.partyType = 'Respondent';
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeRespondent(data){ 
        const form13Data = this.form13Info;       
        form13Data.respondents.splice(data.index,1);
        form13Data.respondentNames = form13Data.respondents.map(resp=>resp.name).join(', ');
        this.partyNames = [...form13Data.appellants, ...form13Data.respondents]
        this.somePartiesChanged()
        this.UpdateForm13Info(form13Data);
        this.updated ++;        
    }

    public addNewAppellant(){
        this.state.appellantsInfo = null
        this.partyToEdit = {} as form13PartiesInfoType
        this.partyType = 'Appellant'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editAppellant(data) {
        this.partyToEdit = data.item
        this.partyType = 'Appellant';
        this.isCreate = false;
        this.showPartyWindow = true;        
    }

    public removeAppellant(data){   
        const form13Data = this.form13Info;       
        form13Data.appellants.splice(data.index,1); 
        form13Data.appellantNames = form13Data.appellants.map(resp=>resp.name).join(', ');
        this.partyNames = [...form13Data.appellants, ...form13Data.respondents]        
        this.somePartiesChanged()
        this.UpdateForm13Info(form13Data);
        this.updated ++;        
    }

    public partyChanged(partyCreated){
        if(partyCreated){
            const form13Info = this.form13Info
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                form13Info.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                form13Info.respondents.push(party);
            }
            this.UpdateForm13Info(form13Info)
        }
        this.revaluateForm13Data();
        this.showPartyWindow = false;
        this.somePartiesChanged() 
        this.updated++;
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form13"}) 
    }

    public somePartiesChanged(){     
        this.form13Info.filingParties = [];
        this.form13Info.signingParties = [];  
        this.updated++;
    }

    public getCounselParty(party){

        if(party.counselName){
            const counsel: form13PartiesInfoType = JSON.parse(JSON.stringify(party))
            counsel.isCounsel = true
            counsel.name = counsel.counselName+', counsel for '+counsel.name
            return counsel
        }        
        return party
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date >= day);           
    }

}
